<ui-card [loading]="isLoading">
    <app-segment-header title="time-off-v3.timeOffRequests"></app-segment-header>

    <div class="group">
        <mat-radio-group
            name="waitingPeriodRadio"
            class="vertical"
            [(ngModel)]="waitingPeriodRadioSelection"
            (ngModelChange)="updateWaitingPeriod()"
        >
            <h4 class="margin-bottom-3">
                {{ 'time-off-v3.policyComponents.timeOffRule.isThereAWaitingPeriod' | translate }}
            </h4>
            <div class="flex col">
                <mat-radio-button class="margin-bottom-1" [value]="false">{{
                    'time-off-v3.policyComponents.timeOffRule.noEmployeesCanRequestTimeOffUnderThisPolicy' | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="true">{{
                    'time-off-v3.policyComponents.timeOffRule.yesThereWillBeAWaitingPeriod' | translate
                }}</mat-radio-button>
            </div>
        </mat-radio-group>
        <ng-container *ngIf="waitingPeriodRadioSelection">
            <div class="margin-left-2 margin-top-3 waiting-period-input">
                <span>{{ 'time-off-v3.policyComponents.timeOffRule.waitingPeriod' | translate }}</span>

                <mat-form-field class="no-labels">
                    <input
                        name="waitingPeriod"
                        matInput
                        [min]="0"
                        [textMask]="{ mask: numberMask }"
                        placeholder="0"
                        required
                        [ngModel]="timeOffRequestRule.getLocalizedProperty('waitingPeriod')"
                        (ngModelChange)="
                            timeOffRequestRule.setLocalizedProperty('waitingPeriod', $event); onTimeOffRequestChange()
                        "
                        #waitingPeriod="ngModel"
                    />
                    <span matSuffix>{{ 'time-off-v3.days' | translate | lowercase }}</span>
                    <mat-error *ngIf="waitingPeriod.invalid">{{ waitingPeriod.errors | formErrors }}</mat-error>
                </mat-form-field>

                <span>{{ 'time-off-v3.policyComponents.timeOffRule.afterTheHireDate' | translate }}</span>
            </div>
        </ng-container>
    </div>

    <div class="group margin-top-3">
        <mat-radio-group
            name="borrowTimeOffRadio"
            class="vertical"
            [(ngModel)]="negativeBalanceCapSelection"
            (ngModelChange)="updateNegativeBalanceCap()"
        >
            <h4 class="margin-bottom-3">
                {{ 'time-off-v3.policyComponents.timeOffRule.doYouAllowEmployeesToBorrowTimeOff' | translate }}
            </h4>
            <div class="flex col">
                <mat-radio-button class="margin-bottom-1" [value]="false">{{
                    'time-off-v3.policyComponents.timeOffRule.noEmployeesCanOnlyBookTheTotal' | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="true">{{
                    'time-off-v3.policyComponents.timeOffRule.yesEmployeesCanBookMore' | translate
                }}</mat-radio-button>
            </div>
        </mat-radio-group>
        <ng-container *ngIf="negativeBalanceCapSelection">
            <div class="container-card margin-top-3">
                <div class="borrow-time-input">
                    <span>{{
                        'time-off-v3.policyComponents.timeOffRule.employeesCanBorrowAMaximumOf' | translate
                    }}</span>

                    <mat-form-field class="no-labels">
                        <input
                            name="borrowTimeOff"
                            matInput
                            [min]="0"
                            required
                            [textMask]="{ mask: numberMask }"
                            [placeholder]="('0.00' | i18nNum) ?? ''"
                            [ngModel]="timeOffRequestRule.getLocalizedProperty('negativeBalanceCap')"
                            (ngModelChange)="timeOffRequestRule.setLocalizedProperty('negativeBalanceCap', $event)"
                            #negCapAt="ngModel"
                        />
                        <span matSuffix>{{ unitOfTime | translate | lowercase }}</span>
                        <mat-error *ngIf="negCapAt.invalid">{{
                            'time-off-v3.policyComponents.timeOffRule.negativeBalanceErrorPositiveRequired' | translate
                        }}</mat-error>
                    </mat-form-field>

                    <span>{{ 'time-off-v3.policyComponents.timeOffRule.withinAnAccrualYear' | translate }}</span>
                </div>

                <ui-banner variant="info">
                    {{ 'time-off-v3.policyComponents.timeOffRule.thisMayResultInANegativeBalance' | translate }}
                </ui-banner>
            </div>
        </ng-container>
    </div>

    <div class="limit-request-container margin-top-3">
        <h4 class="margin-bottom-2">{{ 'time-off-v3.limitRequestLength' | translate }}</h4>

        <div class="field-container">
            <div class="label margin-top-1">
                {{ 'time-off-v3.policyComponents.timeOffRule.minimumLength' | translate }}:
            </div>
            <div>
                <mat-form-field class="no-labels">
                    <input
                        [textMask]="{ mask: numberMask }"
                        [min]="0"
                        name="minLength"
                        matInput
                        [placeholder]="('0.00' | i18nNum) ?? ''"
                        [ngModel]="timeOffRequestRule.getLocalizedProperty('minDayAmount')"
                        (ngModelChange)="
                            timeOffRequestRule.setLocalizedProperty('minDayAmount', $event); onTimeOffRequestChange()
                        "
                        required
                        #minLength="ngModel"
                    />
                    <span matSuffix>{{ unitOfTime | translate | lowercase }}</span>
                    <mat-error *ngIf="minLength.invalid">{{ minLength.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="field-container margin-top-2">
            <div class="label margin-top-1">
                {{ 'time-off-v3.policyComponents.timeOffRule.maximumTotalAmountPerRequest' | translate }}:
            </div>
            <div>
                <mat-form-field class="no-labels">
                    <input
                        [textMask]="{ mask: numberMask }"
                        [min]="0.25"
                        name="maxLength"
                        matInput
                        [placeholder]="('0.00' | i18nNum) ?? ''"
                        [ngModel]="timeOffRequestRule.getLocalizedProperty('maxLength')"
                        (ngModelChange)="
                            timeOffRequestRule.setLocalizedProperty('maxLength', $event); onTimeOffRequestChange()
                        "
                        #maxLength="ngModel"
                    />
                    <span matSuffix>{{ unitOfTime | translate | lowercase }}</span>
                    <mat-error *ngIf="maxLength.invalid">{{ maxLength.errors | formErrors }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
</ui-card>
